
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

interface AppState {
    hasGlobalError: boolean;
    error: FetchBaseQueryError | null;
}

const initialState: AppState = {
    hasGlobalError: false,
    error: null,
};

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        showGlobalError(state, action: PayloadAction<FetchBaseQueryError>) {
            state.hasGlobalError = true;
            state.error = action.payload;
        },
        clearGlobalError(state) {
            state.hasGlobalError = false;
            state.error = null;
        },
    },
});

export const { showGlobalError, clearGlobalError } = appSlice.actions;
export default appSlice.reducer;